import React, { Component } from "react";
import PropTypes from "prop-types";
import ReportCustomFiltersEdiExchange from "./ReportCustomFiltersEdiExchangeContainer";
import ReportCustomFiltersEdiExchange706 from "./ReportCustomFiltersEdiExchange706Container";
import ReportCustomFiltersMrdPodOverview from "./ReportCustomFiltersMrdPodOverviewContainer";
import ReportCustomFiltersTrackedItemsInPredes from "./ReportCustomFiltersTrackedItemsInPredesContainer";
import ReportCustomFilterTypes from "../../../common/redux/actions/types/ReportCustomFilterTypes";
import UserTypes from "../../../common/redux/actions/types/UserTypes";
import ReportCustomFiltersComparative from "./ReportCustomFiltersComparativeContainer";

// eslint-disable-next-line react/prefer-stateless-function
class ReportCustomFilters extends Component {
  render() {
    /* eslint-disable react/destructuring-assignment */
    switch (this.props.type) {
      case ReportCustomFilterTypes.EDI_EXCHANGE_ALL:
        return <ReportCustomFiltersEdiExchange />;
      case ReportCustomFilterTypes.EDI_EXCHANGE_IPC:
        return <ReportCustomFiltersEdiExchange userType={UserTypes.IPC} />;
      case ReportCustomFilterTypes.EDI_EXCHANGE_706:
        return <ReportCustomFiltersEdiExchange706 />;
      case ReportCustomFilterTypes.MRD_POD_OVERVIEW:
        return <ReportCustomFiltersMrdPodOverview />;
      case ReportCustomFilterTypes.TRACKED_ITEMS_IN_PREDES:
        return <ReportCustomFiltersTrackedItemsInPredes />;
      case ReportCustomFilterTypes.COMPARATIVE_TRAY_USAGE_941:
        return <ReportCustomFiltersComparative />;
      case ReportCustomFilterTypes.COMPARATIVE_BAG_USAGE_951:
        return <ReportCustomFiltersComparative />;
      case ReportCustomFilterTypes.COMPARATIVE_PALLET_BOX_USAGE_961:
        return <ReportCustomFiltersComparative />;
      default:
        return <div />;
    }
  }
}

ReportCustomFilters.propTypes = {
  type: PropTypes.string,
};

export default ReportCustomFilters;
